const APP_NAME = 'Real Rates'
const THEME_COLOR = '#1c1917'
const ICON_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/57aafe62-3754-41f2-a96a-b659b0be911a.jpg'

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute(attr, key)
    document.head.appendChild(tag)
  }
  tag.content = content
}

function setLink(rel: string, href: string, type?: string) {
  let tag = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`)
  if (!tag) {
    tag = document.createElement('link')
    tag.rel = rel
    document.head.appendChild(tag)
  }
  tag.href = href
  if (type) tag.type = type
}

/**
 * Makes the published page installable to a phone home screen: iOS reads the
 * apple-* meta tags at "Add to Home Screen" time, Android reads the manifest.
 * The manifest is built at runtime as a blob because this project ships no
 * static index.html to link one from.
 */
export function applyInstallMeta() {
  setMeta('name', 'viewport', 'width=device-width, initial-scale=1, viewport-fit=cover')
  setMeta('name', 'theme-color', THEME_COLOR)
  setMeta('name', 'robots', 'noindex, nofollow')

  // iOS standalone launch — no Safari chrome once installed.
  setMeta('name', 'apple-mobile-web-app-capable', 'yes')
  setMeta('name', 'apple-mobile-web-app-title', APP_NAME)
  setMeta('name', 'apple-mobile-web-app-status-bar-style', 'black-translucent')
  setMeta('name', 'mobile-web-app-capable', 'yes')

  setLink('apple-touch-icon', ICON_URL)
  setLink('icon', ICON_URL)

  document.title = `${APP_NAME} — supplier price lookup`

  const manifest = {
    name: `${APP_NAME} — supplier price lookup`,
    short_name: APP_NAME,
    display: 'standalone',
    orientation: 'portrait',
    background_color: THEME_COLOR,
    theme_color: THEME_COLOR,
    start_url: '.',
    scope: '.',
    icons: [
      // "maskable" lets the launcher crop to its own shape (circle, squircle,
      // rounded square) without leaving light corners around the artwork.
      { src: ICON_URL, sizes: '192x192', type: 'image/jpeg', purpose: 'maskable' },
      { src: ICON_URL, sizes: '512x512', type: 'image/jpeg', purpose: 'maskable' },
      { src: ICON_URL, sizes: '192x192', type: 'image/jpeg', purpose: 'any' },
      { src: ICON_URL, sizes: '512x512', type: 'image/jpeg', purpose: 'any' },
    ],
  }

  const blob = new Blob([JSON.stringify(manifest)], { type: 'application/manifest+json' })
  setLink('manifest', URL.createObjectURL(blob))
}
